import { Box, Typography } from '@mui/material'
import { useMemo } from 'react'

import { useTranslation } from '@/core'
import { Cell } from '@/core/architecture'

export type RevenueLabelProps = {
  type: string
}
enum ContentRevenue {
  deposit = 'deposit',
  withdraw = 'withdraw',
  payout = 'payout',
  bill = 'bill',
}
export const RevenueLabel: Cell<RevenueLabelProps> = ({ type }) => {
  const { t } = useTranslation('consoleRevenue')

  const { bgcolor, text } = useMemo(() => {
    switch (type) {
      case ContentRevenue.deposit:
        return { bgcolor: 'primary.light', text: t('deposit') }
      case ContentRevenue.withdraw:
        return { bgcolor: 'secondary.light', text: t('withdraw') }
      case ContentRevenue.payout:
        return { bgcolor: 'info.light', text: t('payout') }
      case ContentRevenue.bill:
        return { bgcolor: 'info.light', text: t('bill') }
      default:
        return { bgcolor: '', text: '' }
    }
  }, [t, type])

  return (
    <Box display="initial" sx={{ bgcolor, borderRadius: 4, py: 1, px: 2 }}>
      <Typography variant="overline" color="black">
        {text}
      </Typography>
    </Box>
  )
}
